export const formatPriceWithLocale = (
  price: number,
  priceMask: string,
  locale: string,
  noRound?: boolean,
  noPoint?: boolean
): string =>
  price != null && price != undefined && price.toFixed && priceMask
    ? priceMask.replace(
        '{{price}}',
        '<ins>' +
          '&zwj;' +
          Math.trunc(price).toLocaleString(locale).toString() +
          '&zwj;' +
          '</ins>' +
          '<sub>' +
          (!noRound && price >= 100 ? '' : (noPoint ? '' : '.') + price.toFixed(2).split('.')[1]) +
          '</sub>'
      )
    : '---'
